<template lang="pug">
.key-group
  v-checkbox.group-field(
    :inputValue="value",
    @change="$emit('input', $event)",
    :label="$camelToString(field.name)",
    :value="field",
    :value-comparator="comparator"
  )
  template(v-for="childField in (field.fields || [])")
    v-checkbox.primary--text(
      :inputValue="childFieldValues",
      @change="handleChildChange($event, field)",
      :label="$camelToString(childField.name)",
      :value="childField",
    )
</template>

<style lang="scss" scoped>
.key-group {
  ::v-deep .group-field {
    .v-label {
      color: var(--v-primary-base);
      font-weight: 800;
    }
  }
}
</style>

<script>
export default {
  name: 'Key-Group',
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    field: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  computed: {
    childFieldValues () {
      if (!this.value) return [];
      if (!this.field) return [];
      return ((this.value.find(x => x.name === this.field.name) || {}).fields || []);
    },
  },
  methods: {
    comparator(a, b) {
      return a.name == b.name;
    },
    handleChildChange(children, groupField) {
      // console.log('CHILDREN ', children);
      // console.log('GF ', groupField);
      const copyGroup = _.cloneDeep(groupField);
      _.set(copyGroup, 'fields', children)
      // console.log('VALUE ', this.value);
      if (!this.value) this.$emit('input', [copyGroup]);

      const copyValue = _.cloneDeep(this.value);
      const found = _.findIndex(copyValue, ['name', copyGroup.name]);
      // console.log('FOUND ', found);
      if (found != -1) {
        copyValue[found] = copyGroup;
      } else {
        copyValue.push(copyGroup);
      }
      // console.log('copyValue ', copyValue);
      this.$emit('input', copyValue);
    },
  },
}
</script>
